import { useStore } from 'vuex'
import { computed, onBeforeMount } from 'vue'

export default {
    name: "ConfirmDeleteOverlay",
    setup(){
        const store = useStore()
        
        const isSubmitting = computed(()=> store.state.frivillige.is_submitting)
        
        const deleteItemType = computed(()=> store.state.frivillige.delete_item_type)
        const deleteItemName = computed(() => store.state.frivillige.delete_item_name)


        onBeforeMount(() => {
            // creating updated delete_id & delete_name
            store.dispatch('frivillige/getDeleteItemId')
            store.dispatch('frivillige/getDeleteItemName')
            store.dispatch('frivillige/getDeleteItemType')
        })

        const submitConfirmDelete = () => {

            const body = {
                deleteStatus: true
            }

            store.dispatch("frivillige/submitConfirmDelete", {
                body
            })
            .then(() => {
                store.dispatch('main/closePageOverlay')
                store.dispatch('search/refreshSearches')
            });
    
        };

        const closeOverlay = function() {
            store.dispatch('main/closePageOverlay')
        }
        
        const handleRegret = () => {
            closeOverlay()   
        };
        
        const determineLabelCollection = function() {
            if(deleteItemType.value === "Dokument") {
                return "ConfirmDeleteOverlayFile"
            } else if (deleteItemType.value === "Mappe"){
                return "ConfirmDeleteOverlayFolder"
            } else {
                return "ConfirmDeleteOverlay"
            }
        }

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: determineLabelCollection(), labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            isSubmitting,
            deleteItemName,
            getLabel,
            handleRegret,
            submitConfirmDelete
        }
        
    }
}